var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProximus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: white;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.95,182.04c2.16,1.72,5.12,2.57,6.38,2.5l4.39-6.45c-.76-1.22-2.78-3.15-4.25-4.33M299.57,182.04c-2.16,1.72-5.08,2.48-6.43,2.5l-4.38-6.45c.77-1.18,2.82-3.14,4.29-4.32M238.34,238.32c6.94-.53,11.82-6.59,12.65-7.7,6.09-7.64,9.59-20.13,9.61-34.32-.02-14.17-3.52-26.67-9.61-34.31-.84-1.11-5.71-7.17-12.65-7.7-2.72-.21-6.8.37-10.76,4.33-3.96,3.96-4.54,8.03-4.33,10.76.53,6.94,6.59,11.82,7.7,12.65,2.16,1.72,5.12,2.57,6.38,2.5l4.39-6.45c-.76-1.22-2.78-3.15-4.25-4.33l-.18-.14c-.85-.63-3.38-3.09-3.53-5.04-.02-.31-.09-1.14,1.27-2.5,1.36-1.36,2.18-1.3,2.49-1.28,1.72.12,4.05,2.19,5.06,3.53l.14.18c4.52,5.63,7.34,16.28,7.35,27.78-.02,11.52-2.84,22.18-7.35,27.8l-.14.18c-.63.85-3.09,3.38-5.04,3.53-.31.02-1.14.09-2.51-1.27-1.36-1.36-1.3-2.18-1.28-2.49.12-1.72,2.19-4.04,3.53-5.05l.18-.14c1.47-1.18,3.67-3.38,4.25-4.37l-4.39-6.45c-1.4-.03-4.23.83-6.38,2.55-1.11.83-7.17,5.71-7.7,12.65-.21,2.72.37,6.8,4.33,10.76,3.52,3.51,7.13,4.37,9.8,4.37.34,0,.65-.01.96-.04h0ZM293.14,238.35c-.34,0-.65-.01-.96-.04-6.94-.53-11.82-6.59-12.65-7.7-6.09-7.64-9.59-20.13-9.61-34.31.02-14.19,3.52-26.69,9.61-34.32.84-1.11,5.71-7.17,12.65-7.7,2.72-.21,6.8.37,10.76,4.33,3.96,3.96,4.54,8.04,4.33,10.76-.53,6.94-6.59,11.82-7.7,12.65-2.16,1.72-5.08,2.48-6.43,2.5l-4.38-6.45c.77-1.18,2.82-3.14,4.29-4.32l.18-.14c1.34-1.01,3.41-3.33,3.53-5.05.02-.31.08-1.14-1.28-2.49-1.36-1.36-2.19-1.3-2.5-1.27-1.95.15-4.41,2.68-5.04,3.53l-.14.18c-4.52,5.63-7.34,16.28-7.35,27.8.02,11.51,2.83,22.16,7.35,27.78l.14.18c1.01,1.34,3.33,3.41,5.05,3.53.31.02,1.14.08,2.49-1.28,1.36-1.36,1.3-2.19,1.27-2.51-.15-1.95-2.68-4.41-3.53-5.04l-.18-.14c-1.47-1.18-3.04-2.69-4.29-4.37l4.38-6.45c2.16.28,4.27.82,6.43,2.54,1.11.83,7.17,5.71,7.7,12.65.21,2.72-.37,6.8-4.33,10.76-3.52,3.52-7.13,4.37-9.8,4.37h0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M498.85,191.63c-8.96-3.11-10.88-4.02-10.88-6.49,0-2.01,1.01-3.66,5.76-3.66,9.78,0,17.92,2.47,17.92,2.47l2.37-11.06c-4.2-1.37-9.68-2.93-19.92-2.93-15.18,0-18.83,8.04-18.83,15.63s4.02,11.52,17.55,16.18c9.04,3.2,11.33,4.38,11.33,7.13s-2.65,4.75-8.59,4.75c-4.93,0-12.07-1.73-18.1-4.29l-3.01,11.06c5.76,2.83,11.98,4.75,21.03,4.75,15.99,0,21.39-7.59,21.39-16.27s-3.93-12.52-18.01-17.28ZM108.47,212.84c7.59,0,12.52-4.47,12.52-15.26s-4.93-15.36-12.52-15.36-12.52,4.57-12.52,15.36,4.93,15.26,12.52,15.26ZM108.47,225.18c-4.67,0-8.87-1.19-12.52-3.47v24.03h-12.8v-48.16c0-17.73,10.78-27.61,25.32-27.61s25.32,9.87,25.32,27.61-10.79,27.6-25.32,27.6ZM153.98,224.27h-12.8v-31.26c0-13.07,8.5-23.03,23.58-23.03,3.38,0,5.21.46,5.21.46l-2.2,12.34s-1.83-.18-3.02-.18c-7.4,0-10.78,4.48-10.78,11.33v30.35ZM196.49,182.22c-7.59,0-12.98,4.57-12.98,15.36s5.4,15.26,12.98,15.26,13.07-4.47,13.07-15.26-5.4-15.36-13.07-15.36ZM196.49,225.18c-14.53,0-25.78-9.87-25.78-27.6s11.24-27.61,25.78-27.61,25.86,9.87,25.86,27.61-11.33,27.6-25.86,27.6h0ZM367.78,224.27h12.79v-32.91c0-5.4,2.2-9.14,9.78-9.14,6.76,0,9.87,2.92,9.87,9.14v32.91h12.81v-33.82c0-14.53-10.71-20.48-22.68-20.48-5.76,0-12.16,1.83-16.18,5.85-4.02-4.02-10.42-5.85-16.18-5.85-12.52,0-22.67,6.95-22.67,20.48v33.82h12.8v-32.91c0-5.4,2.19-9.14,9.78-9.14,6.77,0,9.88,2.92,9.88,9.14v32.91ZM455.7,170.89v30.53c0,8.78-4.94,11.52-11.06,11.52s-10.97-2.74-10.97-11.52v-30.53h-12.8v30.53c0,15.81,8.23,23.76,23.77,23.76s23.85-7.95,23.85-23.76v-30.53h-12.79ZM314.21,224.27h12.79v-53.38h-12.79v53.38M265.26,191.65c-14.24-.02-26.77-3.55-34.4-9.67l6.6-8.21c5.62,4.52,16.28,7.34,27.8,7.35,11.51-.02,22.16-2.83,27.78-7.35l6.6,8.21c-7.63,6.13-20.16,9.65-34.38,9.67M293.04,218.85c-5.62-4.52-16.28-7.34-27.8-7.35-11.51.02-22.16,2.83-27.78,7.35l-6.6-8.21c7.63-6.13,20.16-9.65,34.38-9.67,14.24.02,26.77,3.55,34.4,9.67l-6.6,8.21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.95,182.04c2.16,1.72,5.12,2.57,6.38,2.5l4.39-6.45c-.76-1.22-2.78-3.15-4.25-4.33M299.57,182.04c-2.16,1.72-5.08,2.48-6.43,2.5l-4.38-6.45c.77-1.18,2.82-3.14,4.29-4.32M238.34,238.32c6.94-.53,11.82-6.59,12.65-7.7,6.09-7.64,9.59-20.13,9.61-34.32-.02-14.17-3.52-26.67-9.61-34.31-.84-1.11-5.71-7.17-12.65-7.7-2.72-.21-6.8.37-10.76,4.33-3.96,3.96-4.54,8.03-4.33,10.76.53,6.94,6.59,11.82,7.7,12.65,2.16,1.72,5.12,2.57,6.38,2.5l4.39-6.45c-.76-1.22-2.78-3.15-4.25-4.33l-.18-.14c-.85-.63-3.38-3.09-3.53-5.04-.02-.31-.09-1.14,1.27-2.5,1.36-1.36,2.18-1.3,2.49-1.28,1.72.12,4.05,2.19,5.06,3.53l.14.18c4.52,5.63,7.34,16.28,7.35,27.78-.02,11.52-2.84,22.18-7.35,27.8l-.14.18c-.63.85-3.09,3.38-5.04,3.53-.31.02-1.14.09-2.51-1.27-1.36-1.36-1.3-2.18-1.28-2.49.12-1.72,2.19-4.04,3.53-5.05l.18-.14c1.47-1.18,3.67-3.38,4.25-4.37l-4.39-6.45c-1.4-.03-4.23.83-6.38,2.55-1.11.83-7.17,5.71-7.7,12.65-.21,2.72.37,6.8,4.33,10.76,3.52,3.51,7.13,4.37,9.8,4.37.34,0,.65-.01.96-.04h0ZM293.14,238.35c-.34,0-.65-.01-.96-.04-6.94-.53-11.82-6.59-12.65-7.7-6.09-7.64-9.59-20.13-9.61-34.31.02-14.19,3.52-26.69,9.61-34.32.84-1.11,5.71-7.17,12.65-7.7,2.72-.21,6.8.37,10.76,4.33,3.96,3.96,4.54,8.04,4.33,10.76-.53,6.94-6.59,11.82-7.7,12.65-2.16,1.72-5.08,2.48-6.43,2.5l-4.38-6.45c.77-1.18,2.82-3.14,4.29-4.32l.18-.14c1.34-1.01,3.41-3.33,3.53-5.05.02-.31.08-1.14-1.28-2.49-1.36-1.36-2.19-1.3-2.5-1.27-1.95.15-4.41,2.68-5.04,3.53l-.14.18c-4.52,5.63-7.34,16.28-7.35,27.8.02,11.51,2.83,22.16,7.35,27.78l.14.18c1.01,1.34,3.33,3.41,5.05,3.53.31.02,1.14.08,2.49-1.28,1.36-1.36,1.3-2.19,1.27-2.51-.15-1.95-2.68-4.41-3.53-5.04l-.18-.14c-1.47-1.18-3.04-2.69-4.29-4.37l4.38-6.45c2.16.28,4.27.82,6.43,2.54,1.11.83,7.17,5.71,7.7,12.65.21,2.72-.37,6.8-4.33,10.76-3.52,3.52-7.13,4.37-9.8,4.37h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.17,183.16c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.16,183.15c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.14,183.14c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.11,183.11c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.06,183.08c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.01,183.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.94,182.98c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.86,182.91c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.77,182.84c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.67,182.76c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.56,182.67c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.45,182.57c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.32,182.46c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.19,182.34c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.05,182.21c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.91,182.08c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.76,181.94c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.6,181.79c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.45,181.63c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.28,181.47c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.12,181.29c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.95,181.12c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.78,180.93c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.61,180.74c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.43,180.54c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.26,180.33c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.09,180.12c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.91,179.9c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.74,179.67c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.57,179.44c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.41,179.2c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.24,178.96c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.08,178.71c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.93,178.45c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.78,178.19c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.63,177.93c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.49,177.66c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.36,177.39c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.23,177.11c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.12,176.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.01,176.54c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.91,176.24c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.81,175.95c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.73,175.65c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.66,175.35c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.6,175.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.55,174.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.52,174.41c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.49,174.1c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.48,173.78c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.49,173.46c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.5,173.13c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.54,172.8c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.59,172.48c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.65,172.14c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.73,171.81c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.83,171.47c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.95,171.14c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.09,170.8c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.24,170.46c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.42,170.12c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.61,169.77c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.83,169.43c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.06,169.09c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.32,168.74c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.61,168.4c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.91,168.05c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.24,167.71c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.58,167.37c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.93,167.06c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.27,166.77c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.62,166.5c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.96,166.25c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.31,166.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.65,165.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.99,165.64c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.33,165.48c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.67,165.34c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.01,165.21c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.34,165.1c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.68,165.02c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.01,164.94c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.34,164.89c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.67,164.85c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237,164.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.32,164.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.64,164.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.96,164.84c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.27,164.87c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.58,164.91c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.89,164.97c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.2,165.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.5,165.11c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.8,165.2c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.09,165.3c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.38,165.41c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.66,165.52c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.94,165.64c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.22,165.77c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.49,165.91c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.76,166.05c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.02,166.2c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.28,166.36c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.53,166.51c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.77,166.68c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.01,166.84c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.25,167.01c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.47,167.18c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.7,167.35c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.91,167.52c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.12,167.7c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.32,167.87c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.52,168.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.71,168.21c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.89,168.38c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.07,168.55c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.23,168.71c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.39,168.87c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.55,169.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.69,169.18c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.83,169.33c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.96,169.47c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.08,169.6c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.19,169.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.29,169.85c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.39,169.96c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.47,170.06c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.55,170.16c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.62,170.24c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.68,170.31c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.73,170.37c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.76,170.43c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.79,170.46c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.81,170.49c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.82,170.5c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.91,170.61c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.04,170.78c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.18,170.96c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.31,171.14c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.45,171.32c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.58,171.5c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.71,171.68c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.84,171.87c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.97,172.06c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.1,172.25c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.23,172.44c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.35,172.63c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.48,172.83c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.6,173.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.73,173.23c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.85,173.43c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.97,173.63c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.09,173.83c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.21,174.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.32,174.25c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,174.46c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.56,174.67c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.67,174.88c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.78,175.1c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.89,175.32c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.01,175.53c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.11,175.75c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.22,175.98c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.33,176.2c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.44,176.42c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.54,176.65c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.65,176.88c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.75,177.11c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.85,177.34c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.95,177.57c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.05,177.81c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.15,178.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.25,178.28c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.34,178.52c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.44,178.76c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.53,179c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.63,179.24c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.72,179.49c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.81,179.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.9,179.98c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.99,180.23c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.07,180.48c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.16,180.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.25,180.98c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.33,181.23c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.41,181.49c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.49,181.74c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.57,182c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.65,182.26c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.73,182.52c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.81,182.78c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.89,183.04c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.96,183.31c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.03,183.57c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.11,183.84c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.18,184.1c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.25,184.37c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.32,184.64c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.38,184.91c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.45,185.18c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.52,185.45c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.58,185.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.65,186c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.71,186.28c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.77,186.55c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.83,186.83c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.89,187.11c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.94,187.39c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254,187.67c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.06,187.95c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.11,188.23c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.16,188.51c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.22,188.8c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.27,189.08c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.32,189.37c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.36,189.65c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.41,189.94c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.46,190.23c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.5,190.51c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.55,190.8c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.59,191.09c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.63,191.38c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.67,191.68c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.71,191.97c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.75,192.26c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.78,192.55c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.82,192.85c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.85,193.14c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.89,193.44c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.92,193.73c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.95,194.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.98,194.33c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.01,194.63c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.04,194.92c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.06,195.22c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.09,195.52c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.11,195.82c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.13,196.12c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.15,196.42c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.17,196.72c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.19,197.03c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.21,197.33c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.23,197.63c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.24,197.93c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.26,198.24c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.27,198.54c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.28,198.84c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.29,199.15c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.3,199.45c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.31,199.76c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.32,200.06c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.32,200.37c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,200.68c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,200.98c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,201.29c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,201.59c2.92,0,5.29-2.37,5.29-5.29s-2.37-5.29-5.29-5.29-5.29,2.37-5.29,5.29,2.37,5.29,5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.17,209.45c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.16,209.46c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.14,209.47c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.11,209.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.06,209.54c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.01,209.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.94,209.63c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.86,209.7c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.77,209.77c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.67,209.85c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.56,209.95c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.45,210.05c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.32,210.15c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.19,210.27c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.05,210.4c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.91,210.53c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.76,210.67c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.6,210.82c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.45,210.98c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.28,211.14c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.12,211.32c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.95,211.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.78,211.68c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.61,211.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.43,212.08c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.26,212.28c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.09,212.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.91,212.72c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.74,212.94c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.57,213.17c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.41,213.41c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.24,213.65c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.08,213.9c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.93,214.16c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.78,214.42c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.63,214.68c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.49,214.95c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.36,215.22c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.23,215.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.12,215.79c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.01,216.07c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.91,216.37c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.81,216.66c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.73,216.96c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.66,217.27c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.6,217.57c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.55,217.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.52,218.2c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.49,218.51c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.48,218.83c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.49,219.15c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.5,219.48c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.54,219.81c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.59,220.14c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.65,220.47c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.73,220.8c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.83,221.14c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.95,221.47c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.09,221.81c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.24,222.15c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.42,222.49c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.61,222.84c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.83,223.18c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.06,223.52c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.32,223.87c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.61,224.21c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.91,224.56c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.24,224.9c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.58,225.24c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.93,225.55c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.27,225.85c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.62,226.11c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.96,226.36c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.31,226.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.65,226.79c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.99,226.97c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.33,227.13c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.67,227.27c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.01,227.4c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.34,227.51c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.68,227.6c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.01,227.67c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.34,227.72c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.67,227.76c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237,227.79c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.32,227.8c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.64,227.79c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.96,227.77c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.27,227.74c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.58,227.7c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.89,227.64c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.2,227.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.5,227.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.8,227.41c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.09,227.31c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.38,227.21c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.66,227.09c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.94,226.97c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.22,226.84c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.49,226.7c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.76,226.56c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.02,226.41c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.28,226.25c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.53,226.1c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.77,225.94c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.01,225.77c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.25,225.6c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.47,225.43c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.7,225.26c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.91,225.09c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.12,224.91c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.32,224.74c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.52,224.57c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.71,224.4c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.89,224.23c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.07,224.06c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.23,223.9c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.39,223.74c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.55,223.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.69,223.43c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.83,223.28c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.96,223.14c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.08,223.01c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.19,222.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.29,222.76c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.39,222.65c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.47,222.55c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.55,222.45c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.62,222.37c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.68,222.3c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.73,222.24c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.76,222.19c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.79,222.15c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.81,222.12c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.82,222.11c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.91,222c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.04,221.83c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.18,221.65c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.31,221.47c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.45,221.29c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.58,221.11c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.71,220.93c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.84,220.74c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.97,220.55c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.1,220.36c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.23,220.17c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.35,219.98c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.48,219.78c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.6,219.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.73,219.38c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.85,219.18c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.97,218.98c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.09,218.78c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.21,218.57c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.32,218.36c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,218.15c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.56,217.94c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.67,217.73c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.78,217.51c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.89,217.29c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.01,217.08c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.11,216.86c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.22,216.63c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.33,216.41c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.44,216.19c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.54,215.96c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.65,215.73c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.75,215.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.85,215.27c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.95,215.04c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.05,214.8c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.15,214.57c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.25,214.33c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.34,214.09c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.44,213.85c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.53,213.61c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.63,213.37c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.72,213.13c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.81,212.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.9,212.63c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.99,212.38c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.07,212.13c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.16,211.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.25,211.63c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.33,211.38c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.41,211.12c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.49,210.87c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.57,210.61c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.65,210.35c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.73,210.09c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.81,209.83c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.89,209.57c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.96,209.3c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.03,209.04c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.11,208.77c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.18,208.51c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.25,208.24c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.32,207.97c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.38,207.7c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.45,207.43c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.52,207.16c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.58,206.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.65,206.61c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.71,206.33c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.77,206.06c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.83,205.78c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.89,205.5c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.94,205.22c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254,204.94c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.06,204.66c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.11,204.38c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.16,204.1c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.22,203.81c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.27,203.53c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.32,203.25c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.36,202.96c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.41,202.67c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.46,202.38c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.5,202.1c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.55,201.81c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.59,201.52c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.63,201.23c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.67,200.93c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.71,200.64c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.75,200.35c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.78,200.06c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.82,199.76c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.85,199.47c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.89,199.17c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.92,198.88c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.95,198.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.98,198.28c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.01,197.98c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.04,197.69c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.06,197.39c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.09,197.09c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.11,196.79c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.13,196.49c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.15,196.19c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.17,195.89c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.19,195.58c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.21,195.28c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.23,194.98c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.24,194.68c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.26,194.37c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.27,194.07c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.28,193.77c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.29,193.46c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.3,193.16c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.31,192.85c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.32,192.55c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.32,192.24c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,191.94c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,191.63c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,191.32c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.33,191.02c2.92,0,5.29,2.37,5.29,5.29s-2.37,5.29-5.29,5.29-5.29-2.37-5.29-5.29,2.37-5.29,5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.35,183.16c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.36,183.15c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.38,183.14c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,183.11c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.46,183.08c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.51,183.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.58,182.98c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.66,182.91c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.75,182.84c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.85,182.76c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.96,182.67c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.07,182.57c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.2,182.46c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.33,182.34c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.47,182.21c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.61,182.08c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.76,181.94c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.92,181.79c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.07,181.63c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.24,181.47c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.4,181.29c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.57,181.12c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.74,180.93c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.91,180.74c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.09,180.54c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.26,180.33c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.43,180.12c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.61,179.9c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.78,179.67c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.95,179.44c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.11,179.2c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.27,178.96c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.44,178.71c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.59,178.45c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.74,178.19c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.89,177.93c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.03,177.66c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.16,177.39c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.28,177.11c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.4,176.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.51,176.54c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.61,176.24c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.71,175.95c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.79,175.65c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.86,175.35c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.92,175.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.97,174.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,174.41c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.03,174.1c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.04,173.78c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.03,173.46c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.02,173.13c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.98,172.8c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.93,172.48c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.87,172.14c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.78,171.81c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.69,171.47c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.57,171.14c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.43,170.8c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.28,170.46c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.1,170.12c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.91,169.77c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.69,169.43c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.46,169.09c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.2,168.74c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.91,168.4c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.61,168.05c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.28,167.71c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.94,167.37c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.59,167.06c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.25,166.76c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.9,166.5c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.56,166.25c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.21,166.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.87,165.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.53,165.64c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.19,165.48c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.85,165.34c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.51,165.21c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.17,165.1c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.84,165.02c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.51,164.94c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.18,164.89c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.85,164.85c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.52,164.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.2,164.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.88,164.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.56,164.84c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.25,164.87c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.94,164.91c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.63,164.97c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.32,165.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.02,165.11c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.73,165.2c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.43,165.3c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.14,165.41c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.86,165.52c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.58,165.64c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.3,165.77c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.03,165.91c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.76,166.05c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.5,166.2c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.24,166.36c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.99,166.51c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.75,166.68c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.51,166.84c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.27,167.01c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.05,167.18c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.82,167.35c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.61,167.52c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.4,167.7c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.2,167.87c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286,168.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.81,168.21c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.63,168.38c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.45,168.55c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.29,168.71c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.12,168.87c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.97,169.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.83,169.18c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.69,169.33c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.56,169.47c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.44,169.6c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.33,169.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.23,169.85c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.13,169.96c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.05,170.06c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.97,170.16c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.9,170.24c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.84,170.31c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.8,170.37c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.76,170.43c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.73,170.46c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.71,170.49c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.7,170.5c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,170.61c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.48,170.78c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.34,170.96c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.21,171.14c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.07,171.32c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.94,171.5c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.81,171.68c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.68,171.87c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.55,172.06c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.42,172.25c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.29,172.44c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.17,172.63c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.04,172.83c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.92,173.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.79,173.23c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.67,173.43c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.55,173.63c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.43,173.83c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.31,174.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.2,174.25c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.08,174.46c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.96,174.67c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.85,174.88c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.74,175.1c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.62,175.32c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.51,175.53c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.4,175.75c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.3,175.98c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.19,176.2c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.08,176.42c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.98,176.65c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.87,176.88c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.77,177.11c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.67,177.34c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.57,177.57c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.47,177.81c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.37,178.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.27,178.28c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.18,178.52c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.08,178.76c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.99,179c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.89,179.24c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.8,179.49c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.71,179.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.62,179.98c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.53,180.23c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.45,180.48c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.36,180.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.27,180.98c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.19,181.23c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.11,181.49c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.03,181.74c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.95,182c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.87,182.26c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.79,182.52c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.71,182.78c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.64,183.04c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.56,183.31c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.49,183.57c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.41,183.84c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.34,184.1c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.27,184.37c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.2,184.64c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.13,184.91c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.07,185.18c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277,185.45c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.94,185.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.87,186c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.81,186.28c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.75,186.55c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.69,186.83c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.63,187.11c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.57,187.39c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.52,187.67c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.46,187.95c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.41,188.23c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.36,188.51c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.3,188.8c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.25,189.08c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.2,189.37c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.16,189.65c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.11,189.94c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.06,190.23c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.02,190.51c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.97,190.8c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.93,191.09c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.89,191.38c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.85,191.68c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.81,191.97c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.77,192.26c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.74,192.55c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.7,192.85c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.67,193.14c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.63,193.44c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.6,193.73c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,194.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.54,194.33c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.51,194.63c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.49,194.92c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.46,195.22c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.43,195.52c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.41,195.82c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.39,196.12c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.37,196.42c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.35,196.72c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.33,197.03c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.31,197.33c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.29,197.63c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.28,197.93c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.26,198.24c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.25,198.54c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.24,198.84c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.23,199.15c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.22,199.45c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.21,199.76c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.2,200.06c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.2,200.37c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,200.68c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,200.98c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,201.29c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,201.59c-2.92,0-5.29-2.37-5.29-5.29s2.37-5.29,5.29-5.29,5.29,2.37,5.29,5.29-2.37,5.29-5.29,5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.35,209.45c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.36,209.46c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.38,209.47c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,209.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.46,209.54c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.51,209.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.58,209.63c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.66,209.7c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.75,209.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.85,209.85c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.96,209.95c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.07,210.05c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.2,210.15c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.33,210.27c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.47,210.4c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.61,210.53c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.76,210.67c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.92,210.82c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.07,210.98c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.24,211.14c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.4,211.32c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.57,211.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.74,211.68c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.91,211.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.09,212.08c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.26,212.28c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.43,212.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.61,212.72c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.78,212.94c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.95,213.17c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.11,213.41c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.27,213.65c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.44,213.9c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.59,214.16c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.74,214.42c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.89,214.68c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.03,214.95c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.16,215.22c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.28,215.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.4,215.79c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.51,216.07c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.61,216.37c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.71,216.66c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.79,216.96c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.86,217.27c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.92,217.57c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.97,217.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302,218.2c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.03,218.51c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.04,218.83c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.03,219.15c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.02,219.48c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.98,219.81c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.93,220.14c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.87,220.47c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.78,220.8c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.69,221.14c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.57,221.47c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.43,221.81c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.28,222.15c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.1,222.49c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.91,222.84c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.69,223.18c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.46,223.52c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.2,223.87c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.91,224.21c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.61,224.56c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.28,224.9c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.94,225.24c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.59,225.55c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.25,225.85c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.9,226.11c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.56,226.36c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.21,226.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.87,226.79c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.53,226.97c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.19,227.13c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.85,227.27c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.51,227.4c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.17,227.51c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.84,227.6c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.51,227.67c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294.18,227.72c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.85,227.76c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.52,227.79c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.2,227.8c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.88,227.79c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.56,227.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.25,227.74c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.94,227.7c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.63,227.64c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.32,227.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.02,227.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.73,227.41c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.43,227.31c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.14,227.21c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.86,227.09c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.58,226.97c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.3,226.84c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.03,226.7c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.76,226.56c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.5,226.41c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.24,226.25c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.99,226.1c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.75,225.94c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.51,225.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.27,225.6c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.05,225.43c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.82,225.26c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.61,225.09c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.4,224.91c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.2,224.74c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286,224.57c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.81,224.4c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.63,224.23c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.45,224.06c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.29,223.9c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.12,223.74c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.97,223.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.83,223.43c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.69,223.28c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.56,223.14c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.44,223.01c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.33,222.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.23,222.76c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.13,222.65c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.05,222.55c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.97,222.45c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.9,222.37c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.84,222.3c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.8,222.24c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.76,222.19c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.73,222.15c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.71,222.12c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.7,222.11c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,222c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.48,221.83c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.34,221.65c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.21,221.47c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.07,221.29c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.94,221.11c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.81,220.93c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.68,220.74c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.55,220.55c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.42,220.36c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.29,220.17c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.17,219.98c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.04,219.78c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.92,219.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.79,219.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.67,219.18c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.55,218.98c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.43,218.78c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.31,218.57c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.2,218.36c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.08,218.15c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.96,217.94c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.85,217.73c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.74,217.51c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.62,217.29c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.51,217.08c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.4,216.86c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.3,216.63c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.19,216.41c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.08,216.19c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.98,215.96c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.87,215.73c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.77,215.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.67,215.27c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.57,215.04c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.47,214.8c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.37,214.57c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.27,214.33c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.18,214.09c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.08,213.85c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.99,213.61c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.89,213.37c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.8,213.13c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.71,212.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.62,212.63c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.53,212.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.45,212.13c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.36,211.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.27,211.63c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.19,211.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.11,211.12c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.03,210.87c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.95,210.61c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.87,210.35c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.79,210.09c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.71,209.83c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.64,209.57c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.56,209.3c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.49,209.04c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.41,208.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.34,208.51c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.27,208.24c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.2,207.97c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.13,207.7c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.07,207.43c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277,207.16c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.94,206.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.87,206.61c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.81,206.33c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.75,206.06c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.69,205.78c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.63,205.5c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.57,205.22c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.52,204.94c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.46,204.66c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.41,204.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.36,204.1c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.3,203.81c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.25,203.53c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.2,203.25c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.16,202.96c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.11,202.67c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.06,202.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.02,202.1c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.97,201.81c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.93,201.52c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.89,201.23c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.85,200.93c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.81,200.64c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.77,200.35c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.74,200.06c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.7,199.76c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.67,199.47c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.63,199.17c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.6,198.88c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,198.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.54,198.28c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.51,197.98c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.49,197.69c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.46,197.39c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.43,197.09c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.41,196.79c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.39,196.49c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.37,196.19c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.35,195.89c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.33,195.58c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.31,195.28c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.29,194.98c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.28,194.68c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.26,194.37c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.25,194.07c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.24,193.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.23,193.46c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.22,193.16c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.21,192.85c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.2,192.55c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.2,192.24c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,191.94c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,191.63c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,191.32c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.19,191.02c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProximus);
export default __webpack_public_path__ + "static/media/proximus.c9e0c7431aa17a0286edc35d6334e512.svg";
export { ForwardRef as ReactComponent };